import { WebUser, UserDocumentsInterface } from '../users/types';
import { DbdInterface } from '../dbds/types';
import { LineInterface, LineSectionBaseInterface } from '../lines/types';
import {
  DbdTokenEntryInterface,
  TransportCardEntryInterface,
} from '../reports/types';

/*
 * Action Types
 */
export enum FacialTypes {
  LIST_FACIAL_REQUEST = '@facial/LIST_FACIAL_REQUEST',
  LIST_FACIAL_SUCCESS = '@facial/LIST_FACIAL_SUCCESS',
  LIST_FACIAL_FAILURE = '@facial/LIST_FACIAL_FAILURE',

  LAST_VALIDATION_LIST_FACIAL_REQUEST = '@facial/LAST_VALIDATION_LIST_FACIAL_REQUEST',
  LAST_VALIDATION_LIST_FACIAL_SUCCESS = '@facial/LAST_VALIDATION_LIST_FACIAL_SUCCESS',
  LAST_VALIDATION_LIST_FACIAL_FAILURE = '@facial/LAST_VALIDATION_LIST_FACIAL_FAILURE',

  GET_SETTINGS_REQUEST = '@facial/GET_SETTINGS_REQUEST',
  GET_SETTINGS_SUCCESS = '@facial/GET_SETTINGS_SUCCESS',
  GET_SETTINGS_FAILURE = '@facial/GET_SETTINGS_FAILURE',

  GET_USER_STATUS_REQUEST = '@facial/GET_USER_STATUS_REQUEST',
  GET_USER_STATUS_SUCCESS = '@facial/GET_USER_STATUS_SUCCESS',
  GET_USER_STATUS_FAILURE = '@facial/GET_USER_STATUS_FAILURE',

  GET_UPLOAD_STATUS_REQUEST = '@facial/GET_UPLOAD_STATUS_REQUEST',
  GET_UPLOAD_STATUS_SUCCESS = '@facial/GET_UPLOAD_STATUS_SUCCESS',
  GET_UPLOAD_STATUS_FAILURE = '@facial/GET_UPLOAD_STATUS_FAILURE',

  UPDATE_SETTINGS_REQUEST = '@facial/UPDATE_SETTINGS_REQUEST',
  UPDATE_SETTINGS_SUCCESS = '@facial/UPDATE_SETTINGS_SUCCESS',
  UPDATE_SETTINGS_FAILURE = '@facial/UPDATE_SETTINGS_FAILURE',

  UPDATE_APPROVAL_STATUS_REQUEST = '@facial/UPDATE_APPROVAL_STATUS_REQUEST',
  UPDATE_APPROVAL_STATUS_SUCCESS = '@facial/UPDATE_APPROVAL_STATUS_SUCCESS',
  UPDATE_APPROVAL_STATUS_FAILURE = '@facial/UPDATE_APPROVAL_STATUS_FAILURE',

  DELETE_FACIAL_REQUEST = '@facial/DELETE_FACIAL_REQUEST',
  DELETE_FACIAL_SUCCESS = '@facial/DELETE_FACIAL_SUCCESS',
  DELETE_FACIAL_FAILURE = '@facial/DELETE_FACIAL_FAILURE',

  LIST_FACIAL_DAILY_RESUME_REQUEST = '@facial/LIST_FACIAL_DAILY_RESUME_REQUEST',
  LIST_FACIAL_DAILY_RESUME_SUCCESS = '@facial/LIST_FACIAL_DAILY_RESUME_SUCCESS',
  LIST_FACIAL_DAILY_RESUME_FAILURE = '@facial/LIST_FACIAL_DAILY_RESUME_FAILURE',

  LIST_FACIAL_DAY_DETAIL_REQUEST = '@facial/LIST_FACIAL_DAY_DETAIL_REQUEST',
  LIST_FACIAL_DAY_DETAIL_SUCCESS = '@facial/LIST_FACIAL_DAY_DETAIL_SUCCESS',
  LIST_FACIAL_DAY_DETAIL_FAILURE = '@facial/LIST_FACIAL_DAY_DETAIL_FAILURE',

  CURRENT_CARD = '@facial/CURRENT_CARD',
  SET_SELECTED_SCORE = '@facial/SET_SELECTED_SCORE',
  SET_SELECTED_STATUS = '@facial/SET_SELECTED_STATUS',
  SET_SELECTED_APPROVAL_STATUS = '@facial/SET_SELECTED_APPROVAL_STATUS',

  CREATE_CHIPS_LIST = '@facial/CREATE_CHIPS_LIST',
  CLEAN_CHIPS_LIST = '@facial/CLEAN_CHIPS_LIST',

  SET_SELECTED_START_DATE = '@facial/SELECTED_START_DATE',
  SET_SELECTED_END_DATE = '@facial/SELECTED_END_DATE',

  SET_SELECTED_VALIDATION_STATUS = '@facial/SET_SELECTED_VALIDATION_STATUS',

  GET_PUBLIC_IMAGE_REQUEST = '@facial/GET_PUBLIC_IMAGE_REQUEST',
  GET_PUBLIC_IMAGE_SUCCESS = '@facial/GET_PUBLIC_IMAGE_SUCCESS',
  GET_PUBLIC_IMAGE_FAILURE = '@facial/GET_PUBLIC_IMAGE_FAILURE',

  CLEAR_PUBLIC_IMAGE_URLS = '@facial/CLEAR_PUBLIC_IMAGE_URLS',

  LAST_GET_PUBLIC_IMAGE_REQUEST = '@facial/LAST_GET_PUBLIC_IMAGE_REQUEST',
  LAST_GET_PUBLIC_IMAGE_SUCCESS = '@facial/LAST_GET_PUBLIC_IMAGE_SUCCESS',
  LAST_GET_PUBLIC_IMAGE_FAILURE = '@facial/LAST_GET_PUBLIC_IMAGE_FAILURE',
}

/*
 * Data types
 */
interface LineSectionInterface extends LineSectionBaseInterface {
  Line: LineInterface;
}

export interface EntryInterface {
  id: string;
  value: number;
  dbdId: string;
  latitude: number;
  lineSectionId: string;
  longitude: number;
  paymentType: number;
  timeout: boolean;
  tripId: string;
  createdAt: string;
  updatedAt: string;
  usedAt: string;
  usedDate: string;
  Dbd: DbdInterface;
  Trip?: any;
  LineSection: LineSectionInterface;
  DbdTokenEntry?: DbdTokenEntryInterface;
  DbdTransportCardEntry?: TransportCardEntryInterface;
}

export interface User extends WebUser {
  document: string;
  UserDocuments: UserDocumentsInterface[];
  Profiles?: { name: string; id: string }[];
  facialStatus?: boolean;
}

export interface FacialInterface {
  id: string;
  key: string;
  status: number;
  approvalStatus: number;
  score: number;
  createdAt: string;
  updatedAt: string;
  userId: string | null;
  entryId: string | null;
  imagesName: string[];
  imagesContainer: string;
  Entry: EntryInterface;
  User: User;
  TransportSupervisor?: { id: string; name: string };
  identifiedUser?: User;
  comment?: string;
  transportOperatorId?: string;
}

export interface FacialSettingsGetInterface {
  id: string;
  blockCount: number;
  blockTime: number;
  blockPercentage: number;
  sendReports: number;
  sendReportEmails: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  resetRecurrenceOnUnblock?: number;
}

export interface UserStatusInterface {
  correct: number;
  suspicous: number;
}

export interface ChipsInterface {
  key: number;
  label: string;
  filter: object;
}

export interface UploadStatusInterface {
  uploaded: number;
  total: number;
  dbd: string;
  line: string;
  place: string;
}

export interface FacialDailyResumeInterface {
  usedDate: Date;
  total: number;
  approved: number;
  reproved: number;
  obstruction: number;
  notset: number;
}

export interface FacialDayDetailInterface {
  name: string;
  id: string;
  startedAt: Date;
  closedAt: Date;
  prefix: string;
  color: string;
  lineName: string;
  total: number;
  approved: number;
  reproved: number;
  obstruction: number;
  notset: number;
}

/*
 * State type
 */
export interface FacialState {
  readonly facialList: FacialInterface[];
  readonly lastValidationFacialList: FacialInterface[];
  readonly facialSettingsData: FacialSettingsGetInterface;
  readonly facialDailyResumeList: FacialDailyResumeInterface[];
  readonly facialDayDetailList: FacialDayDetailInterface[];
  readonly userStatus: UserStatusInterface;
  readonly uploadStatusList: UploadStatusInterface[];
  readonly currentCard: number;
  readonly scorePercent: number | string;
  readonly selectedStatus: number[];
  readonly selectedApprovalStatus: number[];
  readonly selectedValidationStatus: number[];
  readonly chipsList: ChipsInterface[];
  readonly selectedStartDate: Date;
  readonly selectedEndDate: Date;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly loadingStatus: boolean;
  readonly lastValidationLoading: boolean;
  readonly statusLoading: boolean;
  readonly publicImageUrls: string[];
  readonly publicImageLoading: boolean;
  readonly lastPublicImageUrls: Record<string, string[]>;
  readonly lastPublicImageLoading: boolean;
  readonly error: boolean;
}
